export const filterUnique = (arr, obj, uniqueKeyName) => {
  let array = [];
  if (!!arr && arr.length > 0 && obj && Object.keys(obj).length > 0) {
    array = [
      ...new Map(
        [obj, ...arr].map((item) => [item[uniqueKeyName], item]),
      ).values(),
    ];
  } else {
    array.push(obj);
  }
  return array;
};

export const getUniqueObjects = (ObjectArray, key) => {
  let uniqueIds = new Set();
  const list = [
    ...new Set(
      ObjectArray.filter((obj) => {
        if (!uniqueIds.has(obj[key])) {
          uniqueIds.add(obj[key]);
          return obj;
        }
      }),
    ),
  ];

  return list;
};

export const removeDuplicate = (arr, key) => {
  return arr.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t[key] === value[key]),
  );
};

export const updateRecord = (arr, record, uniqueKeyName) => {
  let array = [];
  if (!!arr && arr.length > 0 && record && Object.keys(record).length > 0) {
    array = arr.map((item) => {
      if (item[uniqueKeyName] === record[uniqueKeyName]) {
        return record;
      } else {
        return item;
      }
    });
  }
  return array;
};

export const updateKeyValPair = (arr, record, keys, uniquename) => {
  let array = [];
  if (!!arr && arr.length > 0 && record && Object.keys(record).length > 0) {
    array = arr.map((item) => {
      if (item[uniquename] === record[uniquename]) {
        keys.map((key) => {
          item[key] = record[key];
        });
        return item;
      } else {
        return item;
      }
    });
  }
  return array;
};

export const replaceNullUndefinedEmptyWithKey = (arr, replaceKey) => {
  arr.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      if (obj[key] === null || obj[key] === undefined) {
        if(!key.toLowerCase().includes("id")){
          obj[key] = replaceKey;
        }
      } else if (typeof obj[key] === "string" && obj[key].trim() === "") {
        obj[key] = replaceKey;
      }
    });
  });
  return arr;
};
